<!-- Color Light-Blue  #1a6fb0 -->
<template>
  <div class="bg-secondary">
    <navbar />
    <main class="" style="padding-top: 0rem;">
      <section class="mx-auto" style="max-width: 1200px">
        <div class="px-0 px-xl-5">
          <div class="alert alert-warning alert-with-icon font-size-sm my-0 text-center" role="alert" v-if="evalManager.evalComplete">
            <div class="alert-icon-box">
              <i class="alert-icon czi-time" style="left: 30% !important"></i>
            </div>
            <div class="px-md-5">
              Den Schätzwert deiner Küche haben wir an {{evalManager.userEmail}} geschickt, dort findest du auch den Link, um
              einen persönlichen Termin zu vereinbaren.
            </div>

          </div> 
          <hero id="evaluationCard"/>
          <howItWorks />          
          <explain class="mt-5"/>
          <whyUs class="mb-5 mt-5"/> 
          <newsletter class="pt-3"/>
          <faq class="pt-3"/>
          <div class="pb-4"></div>
        </div>
      </section>
      <myFooter />
    </main>
  </div>
</template>


<script>
import { mapGetters } from 'vuex';
import Vue from "vue"
import navbar from '@/components/navbar.vue'
import hero from './components/hero.vue'
import explain from './components/explain.vue'
import newsletter from './components/newsletter.vue'
import whyUs from './components/whyUs.vue'
import howItWorks from './components/howitworks.vue'
import myFooter from '@/components/footer.vue'
import faq from '@/components/faq.vue'

export default {
  name: 'home',
  components: {
    myFooter,
    howItWorks,
    whyUs,
    navbar,
    hero,
    explain,
    newsletter,
    faq
  },
  data: () => ({
  }),
  computed: {
    ...mapGetters(['evalManager', 'evalManagerError']),
  },
  created: function () {
  },
  mounted: function () {
    Vue.nextTick(() => {
      this.loadBootstrapTheme();
    });
  },
  methods: {
    loadBootstrapTheme: function () {
      let theme = document.createElement('script')
      theme.setAttribute('src', 'theme.js')
      document.head.appendChild(theme) 
    },
  }
}
</script>
